<script>
/* import { tableData } from './data-advance' */
// import SideBar from '../pages/candidate/viewModal'
// import EditSideBar from '../pages/candidate/editModal'

import error from '@utils/error'

import moment from 'moment/moment'
import FormMixin from '@mixins/form'
import applicantProgress from '@components/applicantProgress'
import Multiselect from 'vue-multiselect'
import Dialog from '@components/offcanvas'
import CandidateFilter from './list/candidateListFilter.vue'
import InviteComponent from '../pages/candidate/components/dialogs/invite.vue'
import { EventBus } from '../../event-bus'
export default {
  mixins: [ FormMixin ],
  components:{
    // SideBar, 
    // EditSideBar,
    applicantProgress, 
    Multiselect, 
    Dialog,
    CandidateFilter
  },
  props:{
    sent: {
      type: Boolean,
      default: false
    },
    syncData:{
      type: Boolean,
      default: false
    }
  },
	data() {
		return {
			title: this.$t('candidate.plural'),
			items: [],
			totalRows: 1,
			currentPage: 1,
      perPage: 20,
			perCompany: [],
      perJobTitle: [],
      perStatus: [],
      pageOptions: [20, 50, 100, 200],
      companyOptions: [],
      jobTitleOptions: [],
      statusOptions: [
        { 
          _id: 'pending_admin_approval' ,
          name: 'Pending Admin Approval'
        },
        { 
          _id: 'sent' ,
          name: 'Sent'
        },
        { _id: 'first interview' ,
          name: 'First Interview'
        },
        { _id: 'second interview' ,
          name: 'Second Interview or more'
        },
        { _id: 'pending_consent' ,
          name: 'Pending Consent'
        },
        { _id: 'disapproved' ,
          name: 'Disapproved'
        },
        { _id: 'rejected' ,
          name: 'Rejected'
        },
        
        { _id: 'offered' ,
          name: 'Offered'
        },
        { _id: 'placed' ,
          name: 'Placed'
        },
      ],
      companyFilter: [],
      jobTitleFilter: [],
      jobStatusFilter: [],
			filter: null,
			filterOn: [],
			sortBy: 'date_created',
			sortDesc: true,
			candidateUpdated: false,
      fields: 
      [
        {
          name: 'avatar',
          key: 'avatar',
          title: '',
          label:''
        },
        {
          name: 'full_name',
          sortField: 'full_name',
          key: 'full_name',
          title: this.$t('candidate.table.candidate'),
          label:this.$t('candidate.table.candidate')
        },
        {
          name: 'present_company',
          key: 'present_company',
          title: this.$t('candidate.table.current_employer'),
          label:this.$t('candidate.table.current_employer')
        },
        {
          key: this.sent ? 'company_name' : '',
          label: this.$t('company.singular'),
          title: this.$t('company.singular'),
          class: 'text-center',
          sortable: true
        },
        {
          name: 'date_created',
          key:'date_created',
          title: this.$t('candidate.table.date_created'),
          label: this.$t('candidate.table.date_created'),
          formatter: (value) => {
            return moment(value).format('YYYY-MM-DD')
          }
        },
        {
          name: 'actions',
          key:'actions',
          title: '',
          label:''
        }
      ],
      isBusy:false,
      showModal: false,
      searchText: '',
      candidateID: '',
      isSidebarOpen: false,
      isEditSidebarOpen: false,
      filterItems: {},
		}
	},
	computed: {
		rows() {
			return this.totalRows
		},
    viewComponent() {
      return () => import('../pages/candidate/components/dialogs/view.vue')
    },
    editComponent() {
      return () => import('@pages/job/components/dialogs/createCandidate.vue')
    },
    computedInviteComponent() {
      return InviteComponent
    },
    is_recruiter(){
      return this.$store.state.auth.user.access_type === 'recruitment'
    }
	},
	created() {
    this.fetchData()
    EventBus.$on('onFetchCandidateData', this.fetchData)
	},
  beforeDestroy() {
    EventBus.$off('onFetchCandidateData', this.fetchData)
  },
	methods: {
    filterList(){
      this.fetchData()
    },
    onClickActions(val) {
      if (val && Object.entries(val).length) {
        if (val.type && val.type.toLowerCase() == 'function') {
          this[val.method](val.data)
        }
        else if (val.type && val.type.toLowerCase() == 'ref') {
          this.$refs[val.method].show()
        }
      }
    },
    async onUpdateCandidate(val) {
      if (val.isCreated) {
        this.$refs.edit_side_bar.hide()
        this.fetchData()
        this.$bvToast.toast('Candidate successfully updated!', {
          variant: 'success',
          title: "Notification"
        })
      }

      if(this.candidateID) {
        await this.$refs.side_bar.hide()
      }
      
      if(val.candidateID) {
        this.openFormBar(val.candidateID)
      }

    },
    syncDatas(){
      this.toggleBusy()
      this.$store.dispatch('company/getVincereCandidate', this.model)
      .then(res => {
        if(res.data.status){
          this.fetchData(true)
        }
			})
      .catch(err => error.errorHandler(err, this.$bvToast))
    },
		onFiltered(filteredItems) {
			// Trigger pagination to update the number of buttons/pages due to filtering
			this.totalRows = filteredItems.length
			this.currentPage = 1
    },
    async fetchData(reload = false) {
      if(this.role_modules.some(item => item.value == 'candidate')){
        let param = {}

        if(!reload){
          this.toggleBusy()
        }

        let items = this.filterItems

        param.limit = this.perPage
        param.start = this.currentPage
        param.company = this.companyFilter
        param.job_title = this.jobTitleFilter
        param.status = this.jobStatusFilter
        param.filter = this.filter || items.filter || ''
        param.tags = items.tag

        await this.$store.dispatch('candidate/pagination', param)
        .then(res => {
          this.totalRows = parseInt(res.data.total, 10)
          this.items = res.data.data
          this.getFilteringOptions()
          this.toggleBusy()
        })
      }
    },
    async getFilteringOptions() {
      await this.$store.dispatch('company/getAll')
      .then(res => {
        this.companyOptions = res.data
      })
    },
    toggleBusy() {
      this.isBusy = !this.isBusy
    },
    submitModal() {
      this.companyFilter = []
      this.perCompany.forEach(element => {
        this.companyFilter.push(element._id)
      });
      this.jobTitleFilter = []
      this.perJobTitle.forEach(element => {
        this.jobTitleFilter.push(element._id)
      });
      this.perStatus.forEach(element => {
        this.jobStatusFilter.push(element._id)
      });
      this.fetchData()
      this.showModal = false
    },
    async updateSelected(value) {
      this.companyFilter = []
      value.forEach(element => {
        this.companyFilter.push(element._id)
      });
      await this.$store.dispatch('job/getTitle', { company:this.companyFilter })
      .then(res => {
        this.jobTitleOptions = res.data
      })
      .catch(err => error.errorHandler(err, this.$bvToast))
    },
    openFormBar(id, editMode = false) {
      this.candidateID = id
      if (!editMode) {
        this.$refs.side_bar.show()
      }
      else {
        this.$refs.edit_side_bar.show()
      }
    },
    closeFormBar(result){
      this.isSidebarOpen = result
      this.isEditSidebarOpen = result
    },
    onFilter(val){
      this.filterItems = { ...val } || this.filterItems
      this.fetchData().catch(error => {
        console.error(error)
      })
    },
    showInvitation(){
      this.$refs.inviteModal.show()
    },
    onInviteCandidate(val) {
      let model = val && val.model && Object.entries(val.model).length ? val.model : val

      return this.$store.dispatch('candidate/invite', model)
      .then(res => {
        if (res && res.data) {
          this.$refs.inviteModal.hide();
          this.$bvToast.toast('Email successfully sent to the candidate', {
            variant: 'success',
            title: "Notification"
          });
        }
      })
      .catch(err => {
        return error.errorHandler(err, this.$bvToast);
      })
    },
  },
  watch: {
    currentPage: {
      handler: function() {
        this.fetchData().catch(error => {
          console.error(error)
        })
      }
    },
    perPage: {
      handler: function() {
        this.fetchData().catch(error => {
          console.error(error)
        })
      }
    },
    sent: {
      handler: function() {
        this.fetchData().catch(error => {
          console.error(error)
        })
      }
    }
  }
}
</script>
<template>
<div>
  <div class="d-flex justify-content-between pb-3 align-items-center">
    <div>
      <div class="h3 font-weight-bold my-0">
        {{ $t($route.name.toLowerCase().replace(/ /g, '_') + ".plural") }}
      </div>
      <div class="text-muted my-0">
        <span class="text-primary">Home</span> / {{ $t($route.name.toLowerCase().replace(/ /g, '_') + ".plural") }}
      </div>
    </div>
    <div>
      <button v-if="is_recruiter" class="btn2 btn2-primary btn2-md mr-1 mb-3 mb-sm-0" 
        @click="showInvitation">
        <i class="uil-envelope-share mr-1"></i> Invite Candidate
      </button>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-body">
          <CandidateFilter
            @onFilter="onFilter"
          />

          <!-- Table -->
          <div class="table-responsive mb-0 mt-3">
            <b-table
              :busy="isBusy"
              :items="items"
              :fields="fields"
              responsive="lg"
              :per-page="perPage"
              :current-page="currentPage"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :filter-included-fields="filterOn"
              @filtered="onFiltered"
              :show-empty="true"
              details-td-class="align-middle"
            >

              <template v-slot:cell(actions)="row">
                <div class="d-flex justify-content-end">
                  <router-link
                    class="btn2 btn2-primary btn-sm mx-1 mb-1"
                    tag="button"
                    :to="''"
                    @click.native="openFormBar(row.item._id)"
                  ><i class="uil uil-eye"></i>
                  </router-link>

                  <router-link
                    class="btn2 btn2-primary btn-sm mx-1 mb-1"
                    tag="button"
                    :to="''"
                    @click.native="openFormBar(row.item._id, true)"
                    v-if="role_modules.some(item => item.value == 'candidate.edit')"
                  ><i class="uil uil-edit"></i>
                  </router-link>
                </div>
              </template>

              <template v-slot:cell(full_name)="row">
                <router-link
                  tag="a"
                  class="h6"
                  :to="''"
                  @click.native="openFormBar(row.item._id)"
                  v-if="role_modules.some(item => item.value == 'candidate.view')"
                > {{row.item.full_name}}
                </router-link>
              </template>

              <template v-slot:cell(consent_to_keep)="row">
                {{row.item.consent_to_keep ? row.item.consent_to_keep.consent_to_keep : '-'}}
              </template>

              <template v-slot:cell(right_to_represent)="row">
                {{row.item.right_to_represent ? row.item.right_to_represent.right_to_represent : '-'}}
              </template>


              <template v-slot:cell(applications)="row" v-if="!sent">
                <div class="text-muted small text-center" v-if="!row.item.applications[0]">
                  No Application
                </div>
                <div class="media" v-if="row.item.applications[0]">
                  <div class="media-body">
                    <applicantProgress 
                      :status="row.item.applications[0] ? row.item.applications[0].status : 'Pending'"
                      :applicant="row.item.applications[0]"
                      employment
                    />
                  </div>
                </div>
              </template>

              <template v-slot:cell(applications)="row" v-else>
                <div class="text-muted small text-center" v-if="!row.item.applications[0]">
                  No Application
                </div>
                <div class="media" v-if="row.item.applications[0]">
                  <div class="media-body">
                    {{row.item.applications[0].job_id.title}}
                  </div>
                </div>
              </template>

              <template v-slot:cell(avatar)="row">
                <img 
                  :src="row.item.avatar_path" 
                  alt="avatar" 
                  class="avatar-sm rounded-lg">
              </template>


              <template v-slot:table-busy>
                <div class="text-center text-primary my-2">
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </template>

            </b-table>
          </div>
          <div class="d-flex mb-md-2 justify-content-end">
            <div class="">
              <div class="dataTables_length">
                <label class="d-inline-flex align-items-center dataTable_entries">
                  <span >{{$t('common.show')}}</span>
                  <b-form-select
                    v-model="perPage"
                    size="sm"
                    :options="pageOptions"
                  ></b-form-select>
                  <span >{{$t('common.entries')}}</span>
                </label>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <div
                class="dataTables_paginate paging_simple_numbers float-right"
              >
                <ul class="pagination pagination-rounded mb-0">
                  <!-- pagination -->
                  <b-pagination
                    v-model="currentPage"
                    :total-rows="rows"
                    :per-page="perPage"
                  ></b-pagination>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <b-modal
          id="modal-lg"
          size="lg"
          title="Filter"
          title-class="font-18"
          v-model="showModal"
        >
          <div class="row">
              <div class="form-group col-md-4">
              <label for="" class="form-label">{{$t('company.singular')}}</label>
                <multiselect
                  v-model="perCompany"
                  :options="companyOptions"
                  :searchable="true"
                  :multiple="true"
                  placeholder="All"
                  :clear-on-select="false"
                  :close-on-select="false"
                  :show-labels="false"
                  track-by="_id"
                  value="_id"
                  label="name"
                  @close="updateSelected"
                />
            </div>
            <div class="form-group col-md-4">
              <label for="" class="form-label">{{$t('job.form.title.label')}}</label>
                <multiselect
                  v-model="perJobTitle"
                  :options="jobTitleOptions"
                  :searchable="true"
                  :multiple="true"
                  placeholder="All"
                  :clear-on-select="false"
                  :close-on-select="false"
                  :show-labels="false"
                  track-by="_id"
                  value="_id"
                  label="title"
                ></multiselect>
            </div>
            <div class="form-group col-md-4">
              <label for="" class="form-label">{{$t('user.table.status')}} </label>
                <multiselect
                  v-model="perStatus"
                  :options="statusOptions"
                  :searchable="true"
                  :multiple="true"
                  placeholder="All"
                  :clear-on-select="false"
                  :close-on-select="false"
                  :show-labels="false"
                  track-by="_id"
                  value="_id"
                  label="name"
                ></multiselect>
            </div>
          </div>
          <template v-slot:modal-footer>
            <b-button @click="submitModal" variant="primary">Submit</b-button>
          </template>
      </b-modal>
      </div>

      <Dialog
        title="View Candidate"
        centered
        ref="side_bar"
        size="xl"
        bodyClass="modalBodyContainer px-4"
        :component="viewComponent"
        :parameters="{ candidateID }"
        @onClick="onClickActions"
      />

      <Dialog
        title="Edit Candidate"
        centered
        ref="edit_side_bar"
        size="lg"
        :component="editComponent"
        :parameters="{ candidateID }"
        @onClick="onUpdateCandidate"
      />

      <Dialog
        id="userTypeInvite"
        is_reset_model
        :titleHtml="'<i class=\'uil-envelope-share mr-1\'></i> Invite a Candidate'"
        :component="computedInviteComponent"
        :buttonDisable="invited"
        centered
        size="md"
        ref="inviteModal"
        yesText="Invite"
        noText="Cancel"
        @onYes="onInviteCandidate"
      />
      <!-- <SideBar ref="side_bar" :isSidebarOpen.sync="isSidebarOpen" @closeFormBar="closeFormBar" @openFormBar="openFormBar" :candidateID="candidateID"/> -->
      <!-- <EditSideBar ref="edit_side_bar" :isEditSidebarOpen.sync="isEditSidebarOpen" @closeFormBar="closeFormBar" :candidateID="candidateID"/> -->
    </div>
  </div>
</div>
</template>

<style lang="scss">
 .modalBodyContainer {
    background: #e8eaee;
    overflow: auto;
    height: 80vh;
  }
</style>